var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c(
            "div",
            { staticClass: "page-name", attrs: { id: "benefitHeader" } },
            [_vm._v("View Notification")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "back_button btn btn-primary pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.buttonBack.apply(null, arguments)
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "forms-container" }, [
            _c(
              "div",
              { staticClass: "row no-margin" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "firstName" } }, [
                        _vm._v("Sent By : ")
                      ]),
                      _c("span", [_vm._v(" " + _vm._s(_vm.sent_by) + " ")])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "lastName" } }, [
                        _vm._v("Subject : ")
                      ]),
                      _c("span", [_vm._v(" " + _vm._s(_vm.subject) + " ")])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("span", { staticClass: "pull-right" }, [
                        _vm._v(_vm._s(_vm.sent_at))
                      ]),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "pull-right",
                          attrs: { for: "lastName" }
                        },
                        [_vm._v("Sent At : ")]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _vm.data != ""
                  ? [
                      _c("div", {
                        staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
                        domProps: { innerHTML: _vm._s(_vm.data) }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.attachment != ""
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
                        },
                        [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "lastName" } }, [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      return _vm.getSignedUrlPath(
                                        _vm.attachment
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Attachment")]
                              )
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ]
                  : _vm._e()
              ],
              2
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "div",
            { staticClass: "app-filter-good-table-container" },
            [
              _c("vue-good-table", {
                ref: "hrteamList",
                attrs: {
                  mode: "remote",
                  title: "List User",
                  totalRows: _vm.totalRecords,
                  columns: _vm.columns,
                  rows: _vm.rows,
                  "pagination-options": {
                    enabled: true,
                    mode: "pages",
                    pageLabel: "Page",
                    position: "bottom",
                    perPage: _vm.serverParams.perPage,
                    perPageDropdown: [25, 50, 100, 200, 500],
                    dropdownAllowAll: false
                  },
                  selectOptions: {
                    enabled: false,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: "custom-class",
                    selectionText: "rows selected",
                    clearSelectionText: "clear"
                  },
                  "search-options": {
                    enabled: false
                  }
                },
                on: {
                  "on-page-change": _vm.onPageChange,
                  "on-selected-rows-change": _vm.selectionChanged,
                  "on-column-filter": _vm.onColumnFilter,
                  "on-per-page-change": _vm.onPerPageChange,
                  "on-sort-change": _vm.onSortChange
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container pt-0" }, [
      _c("div", { staticClass: "page-name" }, [_vm._v("Users")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1dedd70e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dedd70e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/user/ViewNotification.vue
// module id = null
// module chunks = 